export default "/images/vendor/flag-icon-css/flags/4x3/na.svg?e241f81665d5aa3bcd027395adb6eb1a";